import { createStore } from 'stimulus-store';

export const printClassesStore = createStore({
    name: 'printClassesStore',
    type: Array,
    initialValue: []
});
